import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import $ from 'jquery';

@Component({
    selector: 'ecom-scroll-to-top',
    templateUrl: './ecom-scroll-to-top.component.html',
    styleUrls: ['./ecom-scroll-to-top.component.scss']
  })
export class ScrollToTopComponent implements OnInit {
    windowScrolled: boolean;
    constructor(@Inject(DOCUMENT) private document: Document) { }
    @HostListener("window:scroll", [])
    onWindowScroll() {
        //console.log('onWindowScroll');
        if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
            this.windowScrolled = true;
        }
        else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
            this.windowScrolled = false;
        }
    }
    scrollToTop() {
        (function smoothscroll() {
            var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            if (currentScroll > 0) {
                //window.requestAnimationFrame(smoothscroll);
                window.scrollTo(0, 0);
            }
        })();
        this.windowScrolled = false;
        // $('html, body').animate({
        //     scrollTop: $('#olarcontent').offset().top
        // }, 100);
        // this.windowScrolled = false;
    }
    ngOnInit() { }
}